import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';

import { ColorAction, OfficeAction } from '../../store/actions';

class Form extends PureComponent {
  static propTypes = {
    authHasOffice: PropTypes.bool,
    authOfficeId: PropTypes.number,
    authOfficeName: PropTypes.string,
    color: PropTypes.object,
    colorId: PropTypes.number,
    createColor: PropTypes.func,
    editColor: PropTypes.func,
    getColor: PropTypes.func,
    getOffices: PropTypes.func,
    offices: PropTypes.arrayOf(PropTypes.object),
  };

  constructor(props) {
    super(props);
    this.state = this.getInitialState(props.color);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    if (this.props.colorId) {
      this.props.getColor(this.props.colorId);
    }
  }

  componentDidUpdate(props, _state, _snapshot) {
    if (JSON.stringify(props.color) !== JSON.stringify(this.props.color)) {
      this.setState({ ...this.getInitialState(this.props.color) });
    }
  }

  getInitialState(color) {
    const officeId = [this.props.authOfficeId, color?.office_id, '']?.find?.(
      i => i,
    );
    const officeSelected = [
      this.props.authOfficeId && {
        label: this.props.authOfficeName,
        value: this.props.authOfficeId,
      },
      color?.office?.id && {
        label: color?.office?.name,
        value: color?.office?.id,
      },
      '',
    ]?.find?.(i => i);
    return {
      name: color?.name || '',
      office_id: officeId || '',
      office_selected: officeSelected || '',
    };
  }

  onChange(event) {
    const { target: { name, value } = {} } = event;
    this.setState({ [name]: value });
  }

  onClear(_) {
    this.setState(this.getInitialState());
  }

  onSelect(option, action) {
    const { _name, name } = action;
    const { value } = option;
    this.setState({ [name]: option, [_name]: value });
  }

  onSubmit(event) {
    event.preventDefault();
    if (!confirm('Are you sure?')) {
      return;
    }
    if (this.props.colorId) {
      this.props.editColor(this.props.colorId, this.state);
    } else {
      this.props.createColor(this.state);
    }
  }

  render() {
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">
                {this.props.colorId ? 'Edit' : 'Create'} Color
              </h3>
            </div>
            <form onSubmit={this.onSubmit.bind(this)}>
              <div className="card-body">
                {!this.props.authHasOffice && (
                  <div className="form-row">
                    <div className="form-group col">
                      <label htmlFor="office_id">Office</label>
                      <Select
                        id="office_id"
                        isDisabled={this.props.authHasOffice}
                        name="office_selected"
                        onChange={(option, action) =>
                          this.onSelect(option, {
                            ...action,
                            _name: 'office_id',
                          })
                        }
                        onInputChange={value => {
                          value && this.props.getOffices({ query: value });
                        }}
                        options={this.props.offices}
                        placeholder="Select Office"
                        value={this.state.office_selected}
                      />
                    </div>
                  </div>
                )}
                <div className="form-row">
                  <div className="form-group col">
                    <label htmlFor="name">Name</label>
                    <input
                      className="form-control"
                      id="name"
                      name="name"
                      onChange={this.onChange}
                      placeholder="Name"
                      type="text"
                      value={this.state.name}
                    />
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <button className="btn btn-primary" type="submit">
                  Save
                </button>
                <button
                  className="btn btn-warning float-right"
                  onClick={this.onClear.bind(this)}
                  type="reset"
                >
                  Clear
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  authHasOffice: !!state?.auth?.office,
  authOfficeId: state?.auth?.office?.id,
  authOfficeName: state?.auth?.office?.name,
  color: state?.color?.detail,
  colorId: Number(props?.match?.params?.id),
  offices: state?.office?.list?.data?.map?.(row => ({
    label: row.name,
    value: row.id,
  })),
});

const mapDispatchToProps = dispatch => ({
  createColor: data => dispatch(ColorAction.createColor(data)),
  editColor: (id, data) => dispatch(ColorAction.editColor(id, data)),
  getColor: id => dispatch(ColorAction.getColor(id)),
  getOffices: params => dispatch(OfficeAction.getOffices(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);
